// @flow
import React from "react";
import { connect } from "react-redux";
import { Translate } from "@quantum/i18n";
import SelectInput from "../../../comum/SelectInput";
import {
  getCorretoresMonetarios,
  selecionarCorretorMonetario,
  getCorretorMonetarioSelecionado,
  type ActionCreator,
} from "../../../../state";

import { ID_OPCAO_CORRETOR_MONETARIO_NENHUM } from "../../../../model";
import type { CorretorMonetario } from "../../../../model";
import { partition, pipe, propEq, propOr, sort } from "ramda";

type Props = {
  listaCorretoresMonetarios: Array<CorretorMonetario>,
  corretorMonetarioSelecionado: string,
  selecionarCorretorMonetario: ActionCreator,
};

function SelecaoCorretorMonetario({
  listaCorretoresMonetarios,
  corretorMonetarioSelecionado,
  selecionarCorretorMonetario,
}: Props) {
  function onChange(corretor) {
    selecionarCorretorMonetario(corretor);
  }

  return (
    <div className="ConfiguracaoMedida__box">
      <label className="ConfiguracaoMedida__label">
        <Translate>ConfiguracaoIndicador.CorrecaoMonetaria</Translate>
      </label>
      <SelectInput
        alwaysOpen={true}
        portal={false}
        options={listaCorretoresMonetarios}
        value={corretorMonetarioSelecionado}
        onChange={onChange}
        size={1}
        multiple={false}
        campoDescricao="nome"
        campoId="codigo"
      />
    </div>
  );
}

export default connect(
  state => ({
    listaCorretoresMonetarios: pipe(
      partition(propEq("codigo", ID_OPCAO_CORRETOR_MONETARIO_NENHUM)),
      ([corretorNenhum, otherCorretores]) => [
        ...corretorNenhum,
        ...sort(
          (corretorA, corretorB) =>
            propOr("", "nome", corretorA).localeCompare(
              propOr("", "nome", corretorB)
            ),
          otherCorretores
        ),
      ]
    )(getCorretoresMonetarios(state)),
    corretorMonetarioSelecionado: getCorretorMonetarioSelecionado(state),
  }),
  { selecionarCorretorMonetario }
)(SelecaoCorretorMonetario);
